addEventListener("DOMContentLoaded", (event) => {
    // get all mobile menu list items that have sub-menus
    const mobileMenuParentLinkItem = document.querySelectorAll(".mobile-navigation li.menu-item-has-children");

    // loop through each item
    mobileMenuParentLinkItem.forEach((linkItem) => {
        // get the link for the parent
        const link = linkItem.querySelector("a");
        // get the sub-menu within
        const subMenu = linkItem.querySelector(".sub-menu");
        // get the parent link text (name for the menu)
        const menuName = link.outerText;
        // get the link it should go to
        const url = link.href;

        // when link is clicked
        link.addEventListener("click", (e) => {
            // prevent the default link action
            e.preventDefault();
            // add "active" class to sub-menu within to reveal it
            subMenu.classList.add("active");
        });

        // create a back button for use within the sub-menu
        const backButton = elementFromHTML(`
            <button class="mobile-menu-back-button">
                <i class="icon-arrow-left"></i>
                Back
            </button>
        `);

        // create a heading for use within the sub-menu that shows the parent name and original link to category
        const subMenuHeading = elementFromHTML(`<a class="sub-menu__heading" href="${url}">${menuName}</a>`);

        // add the two elements to the sub-menu
        subMenu.prepend(subMenuHeading);
        subMenu.prepend(backButton);

        // add an event listener to the back button so that when clicked it removes the "active" class and closes the sub-menu
        backButton.addEventListener("click", (e) => {
            e.target.parentElement.classList.remove("active");
        });
    });
});

// function to take input HTML and return it as rendered HTML
function elementFromHTML(HTML) {
    const template = document.createElement("template");

    template.innerHTML = HTML.trim();

    return template.content.firstElementChild;
}
